/**
 * MobileNav — bottom navigation bar for mobile screens.
 * Shown only on screens smaller than lg (lg:hidden).
 * Uses Lucide React SVGs for accessibility (not emoji).
 * Safe-area-inset padding handles iPhone notch/home indicator.
 *
 * Mirrors the sidebar's "Daily" primary items (Sidebar.tsx PRIMARY_NAV_ITEMS)
 * so desktop and mobile agree on what matters most day-to-day.
 */

import { NavLink } from 'react-router-dom';
import {
  Sun,
  Inbox,
  Calendar,
  FolderOpen,
  Home,
} from 'lucide-react';

const NAV_ITEMS = [
  { name: 'Today',     href: '/app/today',            Icon: Sun        },
  { name: 'Inbox',     href: '/app/messages/unified', Icon: Inbox      },
  { name: 'Calendar',  href: '/app/calendar',          Icon: Calendar   },
  { name: 'Bookings',  href: '/app/bookings',          Icon: FolderOpen },
  { name: 'Properties',href: '/app/properties',        Icon: Home       },
];

export function MobileNav() {
  return (
    <nav
      aria-label="Mobile navigation"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 flex"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {NAV_ITEMS.map(({ name, href, Icon }) => (
        <NavLink
          key={href}
          to={href}
          aria-label={name}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center py-2 min-h-[56px] text-xs gap-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-inset transition-colors ${
              isActive
                ? 'text-blue-600 bg-blue-50 dark:bg-blue-900/20 dark:text-blue-400'
                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800'
            }`
          }
        >
          <Icon size={22} aria-hidden="true" />
          <span className="font-medium">{name}</span>
        </NavLink>
      ))}
    </nav>
  );
}
